import ko from 'knockout';
import _ from 'underscore';
import { TextAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import dynamicTextExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/dynamicTextExtension';
import maxLengthExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/maxLengthExtension';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

function applyFieldRules(opt2fields, options, original) {
  let base = original;

  _.each(opt2fields, (value, key) => {
    if (options[key]) {
      base = _.union(base, value.include || []);
      base = _.difference(base, value.exclude || []);
    }
  });

  return base;
}

function getFields(options) {
  const base = ['Text', 'Title', 'DisplayUrl', 'DevicePreference', 'FinalUrls',
    'TrackingUrlTemplate', 'UrlCustomParameters', 'MobileFinalUrls'];

  const opt2fields = {
    isNativeAdsEnabled: {
      include: ['NativePreference'],
    },
  };

  return applyFieldRules(opt2fields, options, base);
}

export default class {
  constructor({
    model = null,
    isNativeAdsEnabled = false,
    isTraditionalChinese = false,
  } = {}) {
    this.model = model;
    this.isNativeAdsEnabled = isNativeAdsEnabled;

    this.upgradedUrlFields = ['FinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'MobileFinalUrls'];

    koSchema.properties(this, TextAd, getFields({ isNativeAdsEnabled }), _.defaults(model,
      isNativeAdsEnabled ? { NativePreference: 'NativePreference' } : {}));

    dynamicTextExtension.extend(this, ['Title', 'Text']);

    this.isFinal = ko.observable(true);
    this.url = ko.observable('');
    this.mobileUrl = ko.observable('');

    maxLengthExtension(TextAd, this, isTraditionalChinese, ['Title', 'Text']);
  }

  initPreviewTab() {
    this.showNativeAdPreview = ko.computed(() => {
      if (this.isNativeAdsEnabled) {
        return this.NativePreference.isNativePreference();
      }

      return false;
    });

    let defaultPreviewType = 'top';

    if (_.isObject(this.model)) {
      if (this.showNativeAdPreview()) {
        defaultPreviewType = 'native';
      } else if (this.DevicePreference.isMobile()) {
        defaultPreviewType = 'mobile';
      }
    }

    return defaultPreviewType;
  }
}
